import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  tokensPlanList: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "tokens",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.tokenList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.tokenList.fulfilled, (state, { payload }) => {
      const newState = {
        ...state,
        loading: false,
        tokensPlanList: payload.data,
        totalCount: payload.totalcount,
      };

      return newState;
    });
    builder.addCase(Act.tokenList.rejected, (state, action) => ({
      ...state,
      loading: false,
      tokensPlanList: [],
      totalCount: 0,
    }));
    // ADD SUBSCRIPTION
    builder.addCase(Act.TokensAdd.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.TokensAdd.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      marchant: payload,
    }));
    builder.addCase(Act.TokensAdd.rejected, (state, action) => ({
      ...state,
      loading: false,
      marchant: null,
    }));
    // SUBSCRIPTION view deatils
    builder.addCase(Act.tokenDetail.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.tokenDetail.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      marchant: payload,
    }));
    builder.addCase(Act.tokenDetail.rejected, (state, action) => ({
      ...state,
      loading: false,
      marchant: null,
    }));

    // // marchant delete qr
    builder.addCase(Act.deleteTokenPlan.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(Act.deleteTokenPlan.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(Act.deleteTokenPlan.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || action.error;
    });

    //   deleteMarchantQr  // edit
    builder.addCase(Act.editTokenPlan.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(Act.editTokenPlan.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(Act.editTokenPlan.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || action.error;
    });
  },
});

export default slice;
